module.exports = __webpack_public_path__ + "media/xiaoman_02_拍照.2f8f7399.wav";